// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTransferDestinationOptionsV2_OwnershipStakeFragment = { __typename?: 'OwnershipStake', id: string, ownedValue: CurrencyUSD, ownedEntity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'CLTTrust', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'CRTTrust', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'GPBusinessEntity', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'GRATTrust', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'ILITTrust', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'IrrevocableTrust', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'JointPersonalAccount', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'LPBusinessEntity', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'PrivateFoundation', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'QPRTTrust', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'RevocableTrust', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'SLATTrust', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string, taxDiscount?: Percent | null, effectiveDiscountPercent: Percent } } | null };

export type GetTransferDestinationOptionsV2_InsurancePolicyFragment = { __typename?: 'InsurancePolicy', id: string, carrierName?: string | null, cashValue?: CurrencyUSD | null, deathBenefitAmount: CurrencyUSD };

export type GetTransferDestinationOptionsV2QueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.EntityWhereInput>;
}>;


export type GetTransferDestinationOptionsV2Query = { __typename?: 'Query', possibleHypotheticalTransferEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, kind: Types.EntityKind, extendedDisplayKind: string, stage: Types.EntityStage, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null, policies?: Array<(
            { __typename?: 'InsurancePolicy' }
            & GetTransferDestinationOptionsV2_InsurancePolicyFragment
          )> | null } | { __typename?: 'CLTTrust', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null, policies?: Array<(
            { __typename?: 'InsurancePolicy' }
            & GetTransferDestinationOptionsV2_InsurancePolicyFragment
          )> | null } | { __typename?: 'CRTTrust', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null, policies?: Array<(
            { __typename?: 'InsurancePolicy' }
            & GetTransferDestinationOptionsV2_InsurancePolicyFragment
          )> | null } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null, policies?: Array<(
            { __typename?: 'InsurancePolicy' }
            & GetTransferDestinationOptionsV2_InsurancePolicyFragment
          )> | null } | { __typename?: 'GPBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null, policies?: Array<(
            { __typename?: 'InsurancePolicy' }
            & GetTransferDestinationOptionsV2_InsurancePolicyFragment
          )> | null } | { __typename?: 'GRATTrust', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null } | { __typename?: 'ILITTrust', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null, mostRecentValuation?: { __typename?: 'AssetValuationV2', id: string, valuationValue?: CurrencyUSD | null } | null, policies?: Array<(
            { __typename?: 'InsurancePolicy' }
            & GetTransferDestinationOptionsV2_InsurancePolicyFragment
          )> | null } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null, policies?: Array<(
            { __typename?: 'InsurancePolicy' }
            & GetTransferDestinationOptionsV2_InsurancePolicyFragment
          )> | null } | { __typename?: 'IrrevocableTrust', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null, policies?: Array<(
            { __typename?: 'InsurancePolicy' }
            & GetTransferDestinationOptionsV2_InsurancePolicyFragment
          )> | null } | { __typename?: 'JointPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null, policies?: Array<(
            { __typename?: 'InsurancePolicy' }
            & GetTransferDestinationOptionsV2_InsurancePolicyFragment
          )> | null } | { __typename?: 'LPBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null, policies?: Array<(
            { __typename?: 'InsurancePolicy' }
            & GetTransferDestinationOptionsV2_InsurancePolicyFragment
          )> | null } | { __typename?: 'PrivateFoundation', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null, policies?: Array<(
            { __typename?: 'InsurancePolicy' }
            & GetTransferDestinationOptionsV2_InsurancePolicyFragment
          )> | null } | { __typename?: 'QPRTTrust', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null } | { __typename?: 'RevocableTrust', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null, policies?: Array<(
            { __typename?: 'InsurancePolicy' }
            & GetTransferDestinationOptionsV2_InsurancePolicyFragment
          )> | null } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null, policies?: Array<(
            { __typename?: 'InsurancePolicy' }
            & GetTransferDestinationOptionsV2_InsurancePolicyFragment
          )> | null } | { __typename?: 'SLATTrust', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null, policies?: Array<(
            { __typename?: 'InsurancePolicy' }
            & GetTransferDestinationOptionsV2_InsurancePolicyFragment
          )> | null } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD, effectiveDiscountPercent: Percent, taxDiscount?: Percent | null }, ownedOwnershipStakes?: Array<(
          { __typename?: 'OwnershipStake' }
          & GetTransferDestinationOptionsV2_OwnershipStakeFragment
        )> | null, household: { __typename?: 'Household', id: string, possiblePrimaryClients: Array<{ __typename?: 'ClientProfile', id: string, displayName: string, ownedOwnershipStakes?: Array<(
              { __typename?: 'OwnershipStake' }
              & GetTransferDestinationOptionsV2_OwnershipStakeFragment
            )> | null }>, clientProfiles?: Array<{ __typename?: 'ClientProfile', id: string, displayName: string, ownedOwnershipStakes?: Array<(
              { __typename?: 'OwnershipStake' }
              & GetTransferDestinationOptionsV2_OwnershipStakeFragment
            )> | null }> | null, clientOrganizations?: Array<{ __typename?: 'ClientOrganization', id: string, name: string, kind?: Types.ClientOrganizationKind | null }> | null } } | null } | null> | null } };

export const Operations = {
  Query: {
    GetTransferDestinationOptionsV2: 'GetTransferDestinationOptionsV2' as const
  },
  Fragment: {
    GetTransferDestinationOptionsV2_OwnershipStake: 'GetTransferDestinationOptionsV2_OwnershipStake' as const,
    GetTransferDestinationOptionsV2_InsurancePolicy: 'GetTransferDestinationOptionsV2_InsurancePolicy' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GetTransferDestinationOptionsV2_OwnershipStakeFragmentDoc = gql`
    fragment GetTransferDestinationOptionsV2_OwnershipStake on OwnershipStake {
  id
  ownedValue
  ownedEntity {
    id
    subtype {
      id
      displayName
      taxDiscount
      effectiveDiscountPercent
    }
  }
}
    `;
export const GetTransferDestinationOptionsV2_InsurancePolicyFragmentDoc = gql`
    fragment GetTransferDestinationOptionsV2_InsurancePolicy on InsurancePolicy {
  id
  carrierName
  cashValue
  deathBenefitAmount
}
    `;
export const GetTransferDestinationOptionsV2Document = gql`
    query GetTransferDestinationOptionsV2($where: EntityWhereInput) {
  possibleHypotheticalTransferEntities(where: $where) {
    edges {
      node {
        id
        kind
        extendedDisplayKind
        stage
        subtype {
          id
          displayName
          currentValue
          effectiveDiscountPercent
          taxDiscount
          ... on CCorpBusinessEntity {
            id
            policies {
              ...GetTransferDestinationOptionsV2_InsurancePolicy
            }
          }
          ... on GPBusinessEntity {
            id
            policies {
              ...GetTransferDestinationOptionsV2_InsurancePolicy
            }
          }
          ... on LLCBusinessEntity {
            id
            policies {
              ...GetTransferDestinationOptionsV2_InsurancePolicy
            }
          }
          ... on LPBusinessEntity {
            id
            policies {
              ...GetTransferDestinationOptionsV2_InsurancePolicy
            }
          }
          ... on SoleProprietorshipBusinessEntity {
            id
          }
          ... on SCorpBusinessEntity {
            id
            policies {
              ...GetTransferDestinationOptionsV2_InsurancePolicy
            }
          }
          ... on CLTTrust {
            id
            policies {
              ...GetTransferDestinationOptionsV2_InsurancePolicy
            }
          }
          ... on CRTTrust {
            id
            policies {
              ...GetTransferDestinationOptionsV2_InsurancePolicy
            }
          }
          ... on CustodialPersonalAccount {
            id
          }
          ... on DonorAdvisedFund {
            id
            policies {
              ...GetTransferDestinationOptionsV2_InsurancePolicy
            }
          }
          ... on GRATTrust {
            id
          }
          ... on ILITTrust {
            id
            mostRecentValuation {
              id
              valuationValue
            }
            policies {
              ...GetTransferDestinationOptionsV2_InsurancePolicy
            }
          }
          ... on IndividualPersonalAccount {
            id
          }
          ... on InsurancePersonalAccount {
            id
            policies {
              ...GetTransferDestinationOptionsV2_InsurancePolicy
            }
          }
          ... on IrrevocableTrust {
            id
            policies {
              ...GetTransferDestinationOptionsV2_InsurancePolicy
            }
          }
          ... on JointPersonalAccount {
            id
          }
          ... on PrivateFoundation {
            id
            policies {
              ...GetTransferDestinationOptionsV2_InsurancePolicy
            }
          }
          ... on QPRTTrust {
            id
          }
          ... on QualifiedTuitionPersonalAccount {
            id
          }
          ... on RetirementPersonalAccount {
            id
          }
          ... on RevocableTrust {
            id
            policies {
              ...GetTransferDestinationOptionsV2_InsurancePolicy
            }
          }
          ... on SLATTrust {
            id
            policies {
              ...GetTransferDestinationOptionsV2_InsurancePolicy
            }
          }
        }
        ownedOwnershipStakes {
          ...GetTransferDestinationOptionsV2_OwnershipStake
        }
        household {
          id
          possiblePrimaryClients {
            id
            displayName
            ownedOwnershipStakes {
              ...GetTransferDestinationOptionsV2_OwnershipStake
            }
          }
          clientProfiles {
            id
            displayName
            ownedOwnershipStakes {
              ...GetTransferDestinationOptionsV2_OwnershipStake
            }
          }
          clientOrganizations {
            id
            name
            kind
          }
        }
      }
    }
  }
}
    ${GetTransferDestinationOptionsV2_InsurancePolicyFragmentDoc}
${GetTransferDestinationOptionsV2_OwnershipStakeFragmentDoc}`;

/**
 * __useGetTransferDestinationOptionsV2Query__
 *
 * To run a query within a React component, call `useGetTransferDestinationOptionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferDestinationOptionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferDestinationOptionsV2Query({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetTransferDestinationOptionsV2Query(baseOptions?: Apollo.QueryHookOptions<GetTransferDestinationOptionsV2Query, GetTransferDestinationOptionsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferDestinationOptionsV2Query, GetTransferDestinationOptionsV2QueryVariables>(GetTransferDestinationOptionsV2Document, withFetchPolicyContext(options));
      }
export function useGetTransferDestinationOptionsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferDestinationOptionsV2Query, GetTransferDestinationOptionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferDestinationOptionsV2Query, GetTransferDestinationOptionsV2QueryVariables>(GetTransferDestinationOptionsV2Document, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetTransferDestinationOptionsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransferDestinationOptionsV2Query, GetTransferDestinationOptionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransferDestinationOptionsV2Query, GetTransferDestinationOptionsV2QueryVariables>(GetTransferDestinationOptionsV2Document, withFetchPolicyContext(options));
        }
export type GetTransferDestinationOptionsV2QueryHookResult = ReturnType<typeof useGetTransferDestinationOptionsV2Query>;
export type GetTransferDestinationOptionsV2LazyQueryHookResult = ReturnType<typeof useGetTransferDestinationOptionsV2LazyQuery>;
export type GetTransferDestinationOptionsV2SuspenseQueryHookResult = ReturnType<typeof useGetTransferDestinationOptionsV2SuspenseQuery>;
export type GetTransferDestinationOptionsV2QueryResult = Apollo.QueryResult<GetTransferDestinationOptionsV2Query, GetTransferDestinationOptionsV2QueryVariables>;